import { Accordion } from '@mui/material';
import { styled } from '@mui/material/styles';

import { Themes } from '../../constants';
import { getThemeColor } from '../../utils/common';
import { FORTA_BLUE, FORTA_ERROR, FORTA_ORANGE } from '../../utils/colors';

import type { AccordionProps } from '@mui/material';

interface FHAccordionProps extends AccordionProps {
  colorTheme?: Themes;
  hasErrors?: boolean;
  hasWarnings?: boolean;
}

const StyledAccordion = styled(Accordion, {
  shouldForwardProp: (prop) =>
    prop !== 'colorTheme' && prop !== 'hasErrors' && prop !== 'hasWarnings',
})<FHAccordionProps>(({ colorTheme, hasErrors, hasWarnings }) => ({
  borderRadius: '10px',

  border: hasErrors
    ? `2px solid ${FORTA_ERROR}`
    : hasWarnings
      ? `2px solid ${FORTA_ORANGE}`
      : `1px solid ${FORTA_BLUE.light1}`,
  marginBottom: 16,

  '&.Mui-expanded': {
    marginTop: 0,

    '&:last-of-type': {
      marginBottom: 16,
    },
  },
  '&:first-of-type': {
    borderRadius: '10px',
  },
  '&:last-of-type': {
    borderRadius: '10px',
  },
  '&:before': {
    display: 'none',
  },
  '& .MuiAccordionSummary-content': {
    margin: 0,
    '&.Mui-expanded': {
      margin: 0,
    },
  },
  '& .MuiAccordionSummary-expandIconWrapper > .MuiSvgIcon-root': {
    color: getThemeColor(colorTheme).primary,
  },
}));

const FHAccordion = (props: FHAccordionProps) => {
  const { colorTheme = Themes.Primary, children } = props;

  return (
    <StyledAccordion {...props} colorTheme={colorTheme}>
      {children}
    </StyledAccordion>
  );
};

export default FHAccordion;
